import home from '../pages/home.js';
import not_found from '../pages/404.js';

export default {
    name: 'pages',
    label: 'Lehed',
    create: false,
    i18n: {
        structure: 'single_file',
    },
    files: [home, not_found],
};